"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const styles = renderer_1.StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 24,
    },
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24,
        borderBottomColor: 'gray',
        borderBottomWidth: 1,
        fontStyle: 'bold',
        flexGrow: 1,
        fontSize: 10,
    },
    row: {
        flexDirection: 'row',
        height: 36,
    },
    paymentType: {
        width: '30%',
        textAlign: 'left',
        paddingLeft: 8,
        paddingTop: 8,
        fontSize: 10,
    },
    subscriptionType: {
        width: '40%',
        textAlign: 'left',
        paddingRight: 8,
        paddingTop: 8,
        fontSize: 10,
    },
    email: {
        width: '30%',
        textAlign: 'left',
        paddingRight: 8,
        paddingTop: 8,
        fontSize: 10,
    },
});
const InvoiceResume = ({ invoice }) => (react_1.default.createElement(renderer_1.View, { style: styles.tableContainer },
    react_1.default.createElement(renderer_1.View, { style: styles.container },
        react_1.default.createElement(renderer_1.Text, { style: styles.paymentType }, "Mode de paiement"),
        react_1.default.createElement(renderer_1.Text, { style: styles.subscriptionType },
            "Abonnement ",
            invoice.subscription),
        react_1.default.createElement(renderer_1.Text, { style: styles.email }, "Prochaine \u00E9ch\u00E9ance")),
    react_1.default.createElement(renderer_1.View, { style: styles.row },
        react_1.default.createElement(renderer_1.Text, { style: styles.paymentType }, invoice.paymentType),
        react_1.default.createElement(renderer_1.Text, { style: styles.subscriptionType }, invoice.subscriptionType),
        react_1.default.createElement(renderer_1.Text, { style: styles.email }, invoice.nextBill))));
exports.default = InvoiceResume;
